/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {useNavigate, useParams} from 'react-router-dom'
import {Flow} from '../editors/WalkthroughSteps'
import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {getProducts} from '../../../../../redux/action/api'
import {addToCart} from '../../../../../redux/action/card'
import {KTIcon} from '../../../../../_4threal/helpers'

function MenuItem(props: any) {
  const {onLinkClick, hoverTarget, setHoverTarget} = props.shared
  const {url, img} = props
  const {product} = props
  let {title} = props

  if (title === undefined) {
    title = img
  }

  const itemStyle = 'col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 py-3'
  return (
    <div className={itemStyle}>
      <div>{title}</div>
      <div
        onMouseEnter={(e) => {
          setHoverTarget(title)
        }}
        onMouseLeave={(e) => {
          setHoverTarget('none')
        }}
      >
        <img
          style={{maxHeight: '200px'}}
          src={`/media/menu-products/${img}${hoverTarget === title ? '.gif' : '.png'}`}
          alt=''
          onError={(e) => {
            // Fallback to PNG if GIF is not found
            if (e.currentTarget.src.endsWith('.gif')) {
              e.currentTarget.src = `/media/menu-products/${img}.png`
            }
          }}
        />
      </div>
      {Object.keys(product.variants).map((key: any, index: number) => {
        return (
          <button
            onClick={() => onLinkClick(`${url}`, product, key)}
            className='btn btn-sm btn-primary m-2'
            key={index}
          >
            {key} - ${product.variants[key].price.toFixed(2)}
          </button>
        )
      })}
    </div>
  )
}

function ProductMenu() {
  const navigate = useNavigate()
  const {flow, repeatId} = useParams() // The current value at the end of the compiler URL
  const isAdmin = useSelector((state: any) => state.Auth?.authProfile?.userData?.protected?.isAdmin)
  const [hoverTarget, setHoverTarget] = useState('none')
  const products = useSelector((state: any) => state.Api?.products || {})
  const dispatch = useDispatch()
  
  // Custom dimensions modal state
  const [showCustomModal, setShowCustomModal] = useState(false)
  const [customWidth, setCustomWidth] = useState('')
  const [customHeight, setCustomHeight] = useState('')
  const [selectedCustomProduct, setSelectedCustomProduct] = useState<any>(null)
  const [selectedCustomVariant, setSelectedCustomVariant] = useState('')
  const [customErrors, setCustomErrors] = useState({ width: '', height: '' })

  const getFlowName = () => Flow[flow || 'full']

  const validateCustomDimensions = () => {
    const errors = { width: '', height: '' }
    let isValid = true

    const width = parseFloat(customWidth)
    const height = parseFloat(customHeight)

    if (!customWidth || isNaN(width) || width <= 0) {
      errors.width = 'Please enter a valid width greater than 0'
      isValid = false
    } else if (width > 50) {
      errors.width = 'Width cannot exceed 50 inches'
      isValid = false
    }

    if (!customHeight || isNaN(height) || height <= 0) {
      errors.height = 'Please enter a valid height greater than 0'
      isValid = false
    } else if (height > 50) {
      errors.height = 'Height cannot exceed 50 inches'
      isValid = false
    }

    setCustomErrors(errors)
    return isValid
  }

  const handleCustomDimensionsSubmit = () => {
    if (!validateCustomDimensions()) {
      return
    }

    const width = parseFloat(customWidth)
    const height = parseFloat(customHeight)
    
    // Create updated product with custom dimensions
    const updatedProduct = {
      ...selectedCustomProduct,
      print_files: {
        ...selectedCustomProduct.print_files,
        custom: {
          ...selectedCustomProduct.print_files.custom,
          width: width,
          height: height
        }
      }
    }

    // Close modal and proceed with cart item creation
    setShowCustomModal(false)
    createCartItemWithCustomDimensions('custom', updatedProduct, selectedCustomVariant, width, height)
    
    // Reset form
    setCustomWidth('')
    setCustomHeight('')
    setSelectedCustomProduct(null)
    setSelectedCustomVariant('')
    setCustomErrors({ width: '', height: '' })
  }

  const createCartItemWithCustomDimensions = (markerType: string, product: any, variantId: string, width: number, height: number) => {
    const variant = product.variants[variantId]
    const cartItem: any = {
      product_id: product.product_id,
      icon_id: markerType,
      variant_id: variant.variant_id,
      printful_variant_id: variant.printful_variant_id,
      print_data: {
        ...product.print_files.custom,
        width: width,
        height: height
      },
      name: `${product.name} (${width}" x ${height}")`,
      size: `${width}" x ${height}"`,
      color: variant.color,
      in_stock: variant.is_active,
      price: variant.price,
      requires_activation: true,
      scene_id: 'temp',
      quantity: 1,
      custom_dimensions: {
        width: width,
        height: height,
        ratio: width / height
      }
    }

    if (repeatId === 'noid') {
      //create a new marker and experience
      localStorage.setItem('tempCartItem', JSON.stringify(cartItem))
      window.location.href = `/vcard/compiler/${getFlowName()}/${markerType}/noid`
    } else {
      //send the previous sceneId to the compiler
      navigate(`/vcard/compiler/${getFlowName()}/${markerType}/${repeatId}`)
    }
  }

  const onLinkClick = (markerType: string, product: any, variantId: string) => {
    // Handle custom product differently - show modal for dimensions
    if (markerType === 'custom') {
      setSelectedCustomProduct(product)
      setSelectedCustomVariant(variantId)
      setShowCustomModal(true)
      return
    }

    // Handle normal products
    let variant = product.variants[variantId]
    let cartItem: any = {
      product_id: product.product_id,
      icon_id: markerType,
      variant_id: variant.variant_id,
      printful_variant_id: variant.printful_variant_id,
      print_data: product.print_files[variant.print_file],
      name: product.name,
      size: variant.size,
      color: variant.color,
      in_stock: variant.is_active,
      price: variant.price,
      requires_activation: true,
      scene_id: 'temp',
      quantity: 1,
    }

    if (repeatId === 'noid') {
      //create a new marker and experience
      localStorage.setItem('tempCartItem', JSON.stringify(cartItem))
      window.location.href = `/vcard/compiler/${getFlowName()}/${markerType}/noid`
    } else {
      //send the previous sceneId to the compiler
      navigate(`/vcard/compiler/${getFlowName()}/${markerType}/${repeatId}`)
    }
  }

  useEffect(() => {
    dispatch(getProducts())
    localStorage.setItem('tempCartItem', '')
  }, []) //runs on mount

  useEffect(() => {
    console.log('productres', products)
  }, [products]) //runs on mount

  const shared = {
    onLinkClick: onLinkClick,
    hoverTarget: hoverTarget,
    setHoverTarget: setHoverTarget,
    isAdmin: isAdmin,
  }

  return (
    <div className='w-100 h-100 d-flex flex-column align-items-center justify-content-center'>
      {flow === Flow.repeat ? (
        <img
          style={{maxHeight: '120px', width: '100%'}}
          alt=''
          src='/media/menu-products/_MenuSelectAdditional.svg'
        />
      ) : (
        <img
          style={{maxHeight: '120px', width: '100%'}}
          alt=''
          src='/media/menu-products/_MenuTitleHeader.svg'
        />
      )}
      <div className='w-100 d-flex flex-column flex-sm-row align-items-center justify-content-center gap-4'>
        <div
          className='row'
          style={{
            margin: '15px',
            fontSize: '15px',
            textAlign: 'center',
            paddingLeft: '10vw',
            paddingRight: '10vw',
          }}
        >
          {Object.keys(products).length === 0 && <p className='fs-1'>Loading...</p>}
          {Object.keys(products).map((pkey: any, index: number) => {
            return products[pkey].in_stock ? (
              <MenuItem
                shared={shared}
                key={index}
                url={pkey}
                img={pkey}
                product={products[pkey]}
                title={products[pkey]?.name}
              />
            ) : (
              <div key={index}></div>
            )
          })}
        </div>
      </div>

      {/* Custom Dimensions Modal */}
      {showCustomModal && (
        <>
          <div className='modal fade show d-block' role='dialog' tabIndex={-1} style={{ display: 'flex', padding: '40px' }} aria-modal='true'>
            <div className='modal-dialog modal-dialog-centered'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h2 className='fw-bolder'>Custom Print Dimensions</h2>
                  <div 
                    onClick={() => {
                      setShowCustomModal(false)
                      setCustomErrors({ width: '', height: '' })
                    }} 
                    className='btn btn-icon btn-sm btn-active-icon-primary cur-pointer'
                  >
                    <KTIcon iconName='cross' className='fs-1' />
                  </div>
                </div>
                <div className='modal-body'>
                  <div className='mb-5'>
                    <p className='text-muted mb-4'>
                      Enter the dimensions for your custom print. These will be used to create the correct aspect ratio for your design.
                    </p>
                    
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='fv-row mb-4'>
                          <label className='form-label required'>Width (inches)</label>
                          <input
                            type='number'
                            step='0.1'
                            min='0.1'
                            max='50'
                            className={`form-control ${customErrors.width ? 'is-invalid' : ''}`}
                            placeholder='e.g., 8.5'
                            value={customWidth}
                            onChange={(e) => {
                              setCustomWidth(e.target.value)
                              if (customErrors.width) {
                                setCustomErrors(prev => ({ ...prev, width: '' }))
                              }
                            }}
                          />
                          {customErrors.width && (
                            <div className='invalid-feedback'>{customErrors.width}</div>
                          )}
                        </div>
                      </div>
                      
                      <div className='col-md-6'>
                        <div className='fv-row mb-4'>
                          <label className='form-label required'>Height (inches)</label>
                          <input
                            type='number'
                            step='0.1'
                            min='0.1'
                            max='50'
                            className={`form-control ${customErrors.height ? 'is-invalid' : ''}`}
                            placeholder='e.g., 11'
                            value={customHeight}
                            onChange={(e) => {
                              setCustomHeight(e.target.value)
                              if (customErrors.height) {
                                setCustomErrors(prev => ({ ...prev, height: '' }))
                              }
                            }}
                          />
                          {customErrors.height && (
                            <div className='invalid-feedback'>{customErrors.height}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    {customWidth && customHeight && !customErrors.width && !customErrors.height && (
                      <div className='alert alert-info'>
                        <strong>Preview:</strong> {customWidth}" × {customHeight}" 
                        (Ratio: {(parseFloat(customWidth) / parseFloat(customHeight)).toFixed(2)}:1)
                      </div>
                    )}
                  </div>
                </div>
                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    onClick={() => {
                      setShowCustomModal(false)
                      setCustomErrors({ width: '', height: '' })
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={handleCustomDimensionsSubmit}
                  >
                    Continue with These Dimensions
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </div>
  )
}

export default ProductMenu
